var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.226 19.8127C16.207 20.8883 15.1183 21.8682 14.0292 22.7354C13.6474 23.0394 13.2922 23.3081 12.9722 23.5392C12.7772 23.68 12.6351 23.7784 12.5547 23.8321C12.2188 24.056 11.7812 24.056 11.4453 23.8321C11.3649 23.7784 11.2228 23.68 11.0278 23.5392C10.7078 23.3081 10.3526 23.0394 9.97082 22.7354C8.88175 21.8682 7.793 20.8883 6.77405 19.8127C3.8024 16.676 2 13.3716 2 10C2 4.47715 6.47715 0 12 0C17.5228 0 22 4.47715 22 10C22 13.3716 20.1976 16.676 17.226 19.8127ZM12.7833 21.1708C13.8036 20.3584 14.8242 19.4398 15.774 18.4373C18.4274 15.6365 20 12.7534 20 10C20 5.58172 16.4183 2 12 2C7.58172 2 4 5.58172 4 10C4 12.7534 5.5726 15.6365 8.22595 18.4373C9.17575 19.4398 10.1964 20.3584 11.2167 21.1708C11.4952 21.3926 11.7577 21.5936 12 21.7726C12.2423 21.5936 12.5048 21.3926 12.7833 21.1708ZM12 14C9.79086 14 8 12.2091 8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14ZM12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12Z",
    fill: "#2C3439"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.7fda48f02e7a1f8dd328049e4a3bebfa.svg";
export { ForwardRef as ReactComponent };